import { Fragment, type ReactNode } from 'react'
import { tokenize, type Token } from '../../lib/text/tokenize'

function render(tokens: Token[], keyPrefix = ''): ReactNode[] {
  return tokens.map((token, index) => {
    const key = `${keyPrefix}${index}`
    switch (token.type) {
      case 'text':
        return <Fragment key={key}>{token.text}</Fragment>
      case 'link':
        return (
          <a key={key} href={token.href} target="_blank" rel="noopener noreferrer">
            {token.text}
          </a>
        )
      case 'mention':
        return (
          <span key={key} className={token.isMe ? 'mention me' : 'mention'}>
            {token.text}
          </span>
        )
      case 'bold':
        return <strong key={key}>{render(token.children, `${key}-`)}</strong>
      case 'code':
        return <code key={key}>{token.text}</code>
    }
  })
}

/** Message body as React elements: links, mentions, *bold* and `code` (never HTML). */
export function MessageText({ body, meUsername }: { body: string; meUsername: string | null }) {
  return <>{render(tokenize(body, { meUsername }))}</>
}
